module.exports = __webpack_public_path__ + "static/media/CorteTelaMin.30bbf6b1.jpg";